// Generated by contracts/settings/gen_settings.py --target admin; do not edit. The descriptors are the generator's JSON, bound to a name so
// TypeScript can import them (web/ui/tests/unit/settings/fields.test.ts regenerates and compares).
export const SETTINGS_FIELDS_DOC = {
  "schemaVersion": 1,
  "source": "contracts/installation-settings.v1.schema.json",
  "sections": [
    {
      "name": "sign_in",
      "owner": "settings-parity",
      "label": "Sign in",
      "required": true
    },
    {
      "name": "identity",
      "owner": "proxy-admin",
      "label": "Identity",
      "required": true
    },
    {
      "name": "admin_access",
      "owner": "proxy-admin",
      "label": "Admin access",
      "required": true
    },
    {
      "name": "models",
      "owner": "settings-parity",
      "label": "Models",
      "required": false
    },
    {
      "name": "guardrails",
      "owner": "settings-parity",
      "label": "Guardrails",
      "required": false
    },
    {
      "name": "upstreams",
      "owner": "settings-parity",
      "label": "Upstreams",
      "required": false
    },
    {
      "name": "org",
      "owner": "settings-parity",
      "label": "Org",
      "required": false
    },
    {
      "name": "web_search",
      "owner": "settings-parity",
      "label": "Web search",
      "required": false
    },
    {
      "name": "quotas",
      "owner": "quotas-reporting",
      "label": "Quotas",
      "required": false
    }
  ],
  "fields": [
    {
      "path": "sign_in",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Sign in",
      "help": "settings.sign_in",
      "widget": null,
      "default": null,
      "required": true,
      "description": "How developers sign in on the proxy (settings parity REQ-061..063, extended by proxy sign-in ADR-092).",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "sign_in.served_by",
        "sign_in.sso_providers",
        "sign_in.iam_keys",
        "sign_in.cognito",
        "sign_in.api_keys",
        "sign_in.aws_sign_in",
        "sign_in.key_policy",
        "sign_in.trusted_tokens"
      ]
    },
    {
      "path": "sign_in.served_by",
      "section": "sign_in",
      "owner": "proxy-sign-in",
      "type": [
        "string"
      ],
      "label": "Served by",
      "help": "settings.sign_in.served_by",
      "widget": null,
      "default": "central",
      "required": true,
      "description": "Who serves `/login` and `/setup*` for this installation (ADR-091). `central`: `nexus-web` answers with the central redirects; `proxy`: the proxy serves sign-in itself. Set only by the flip operation, never by a settings write. The API sets `proxy` for installations registered after REL-481; a proxy with no applied settings waits for them.",
      "apply": "live",
      "customer_editable": false,
      "customer_readonly": false,
      "staff_only": true,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "central",
        "proxy"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "sign_in.sso_providers",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Sso providers",
      "help": "settings.sign_in.sso_providers",
      "widget": null,
      "default": [],
      "required": true,
      "description": "The identity providers people sign in with, in the order `/login` shows them.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 20,
      "unique_items": false,
      "items": {
        "description": "An SSO provider. The `type` decides which of `saml` and `oidc` is read; the settings validator requires that one.",
        "type": "object",
        "additionalProperties": false,
        "required": [
          "id",
          "type",
          "label",
          "enabled",
          "groups_attribute",
          "allowed_email_domains",
          "allowed_groups",
          "team_mappings",
          "secret_name"
        ],
        "properties": {
          "id": {
            "$ref": "#/$defs/providerId"
          },
          "type": {
            "type": "string",
            "enum": [
              "identity_center_saml",
              "okta",
              "google",
              "entra",
              "generic_saml",
              "generic_oidc"
            ],
            "default": "generic_saml"
          },
          "label": {
            "description": "The button's text on `/login`.",
            "type": "string",
            "minLength": 1,
            "maxLength": 64,
            "default": "Sign in with SSO"
          },
          "enabled": {
            "type": "boolean",
            "default": true
          },
          "saml": {
            "type": "object",
            "additionalProperties": false,
            "required": [
              "metadata_url"
            ],
            "properties": {
              "metadata_url": {
                "$ref": "#/$defs/httpsUrl"
              }
            }
          },
          "oidc": {
            "type": "object",
            "additionalProperties": false,
            "required": [
              "issuer",
              "client_id",
              "scopes"
            ],
            "properties": {
              "issuer": {
                "$ref": "#/$defs/httpsUrl"
              },
              "client_id": {
                "type": "string",
                "minLength": 1,
                "maxLength": 256
              },
              "scopes": {
                "type": "array",
                "maxItems": 20,
                "uniqueItems": true,
                "default": [
                  "openid",
                  "email",
                  "profile"
                ],
                "items": {
                  "type": "string",
                  "pattern": "^[A-Za-z0-9_.:/-]{1,128}$"
                }
              }
            }
          },
          "groups_attribute": {
            "description": "The SAML attribute or OIDC claim carrying groups; `null` when the provider sends none.",
            "type": [
              "string",
              "null"
            ],
            "minLength": 1,
            "maxLength": 256,
            "default": null
          },
          "allowed_email_domains": {
            "type": "array",
            "maxItems": 100,
            "uniqueItems": true,
            "default": [],
            "items": {
              "type": "string",
              "pattern": "^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?(\\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)+$"
            }
          },
          "allowed_groups": {
            "type": "array",
            "maxItems": 500,
            "uniqueItems": true,
            "default": [],
            "items": {
              "type": "string",
              "minLength": 1,
              "maxLength": 256
            }
          },
          "team_mappings": {
            "description": "Derived from `identity.team_rules` (proxy admin REQ-102); kept for older proxies.",
            "x-nexus-deprecated": true,
            "readOnly": true,
            "type": "array",
            "maxItems": 200,
            "default": [],
            "items": {
              "type": "object",
              "additionalProperties": false,
              "required": [
                "match",
                "teamExternalId"
              ],
              "properties": {
                "match": {
                  "type": "string",
                  "minLength": 1,
                  "maxLength": 256
                },
                "teamExternalId": {
                  "$ref": "#/$defs/teamExternalId"
                }
              }
            }
          },
          "secret_name": {
            "description": "The Secrets Manager name of the provider's client secret in the proxy account, `nexus/<installationId>/idp/<providerId>`, never its value (ADR-085). The customer admin enters the secret on the proxy (API-486); `null` until then, and for a provider that needs none.",
            "x-nexus-owner": "proxy-sign-in",
            "x-nexus-secret-ref": true,
            "type": [
              "string",
              "null"
            ],
            "pattern": "^nexus/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/idp/[a-z2-7]{12}$",
            "default": null
          }
        }
      },
      "children": []
    },
    {
      "path": "sign_in.iam_keys",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Iam keys",
      "help": "settings.sign_in.iam_keys",
      "widget": null,
      "default": null,
      "required": true,
      "description": "Sign-in with AWS access keys presigned in the browser.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "sign_in.iam_keys.enabled",
        "sign_in.iam_keys.require_mfa"
      ]
    },
    {
      "path": "sign_in.iam_keys.enabled",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "boolean"
      ],
      "label": "Enabled",
      "help": "settings.sign_in.iam_keys.enabled",
      "widget": null,
      "default": true,
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "sign_in.iam_keys.require_mfa",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "boolean"
      ],
      "label": "Require mfa",
      "help": "settings.sign_in.iam_keys.require_mfa",
      "widget": null,
      "default": true,
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "sign_in.cognito",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Cognito",
      "help": "settings.sign_in.cognito",
      "widget": null,
      "default": null,
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "sign_in.cognito.mode",
        "sign_in.cognito.user_pool_id",
        "sign_in.cognito.client_id",
        "sign_in.cognito.mfa"
      ]
    },
    {
      "path": "sign_in.cognito.mode",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Mode",
      "help": "settings.sign_in.cognito.mode",
      "widget": null,
      "default": "create",
      "required": true,
      "description": "`disabled`, `create` (a pool made by the IaC) or `existing` (`user_pool_id` and `client_id`).",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "disabled",
        "create",
        "existing"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "sign_in.cognito.user_pool_id",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "string",
        "null"
      ],
      "label": "User pool id",
      "help": "settings.sign_in.cognito.user_pool_id",
      "widget": null,
      "default": null,
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": "^[a-z]{2}(-gov)?-[a-z]+-[0-9]_[A-Za-z0-9]{1,55}$",
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "sign_in.cognito.client_id",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "string",
        "null"
      ],
      "label": "Client id",
      "help": "settings.sign_in.cognito.client_id",
      "widget": null,
      "default": null,
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": "^[a-z0-9]{1,128}$",
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "sign_in.cognito.mfa",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Mfa",
      "help": "settings.sign_in.cognito.mfa",
      "widget": null,
      "default": "optional",
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "off",
        "optional",
        "required"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "sign_in.api_keys",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Api keys",
      "help": "settings.sign_in.api_keys",
      "widget": null,
      "default": null,
      "required": true,
      "description": "Admin-issued keys. They are imported from the central store (`source = admin`); no route on the proxy mints one.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "sign_in.api_keys.enabled"
      ]
    },
    {
      "path": "sign_in.api_keys.enabled",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "boolean"
      ],
      "label": "Enabled",
      "help": "settings.sign_in.api_keys.enabled",
      "widget": null,
      "default": true,
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "sign_in.aws_sign_in",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Aws sign in",
      "help": "settings.sign_in.aws_sign_in",
      "widget": null,
      "default": null,
      "required": true,
      "description": "The `nxa_` automation sign-in: a presigned sts:GetCallerIdentity request.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "sign_in.aws_sign_in.enabled",
        "sign_in.aws_sign_in.allowed_accounts",
        "sign_in.aws_sign_in.allowed_principals",
        "sign_in.aws_sign_in.team_mappings"
      ]
    },
    {
      "path": "sign_in.aws_sign_in.enabled",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "boolean"
      ],
      "label": "Enabled",
      "help": "settings.sign_in.aws_sign_in.enabled",
      "widget": null,
      "default": true,
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "sign_in.aws_sign_in.allowed_accounts",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Allowed accounts",
      "help": "settings.sign_in.aws_sign_in.allowed_accounts",
      "widget": null,
      "default": [],
      "required": true,
      "description": "AWS account ids, besides the installation's own, whose principals may sign in.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 100,
      "unique_items": true,
      "items": {
        "type": "string",
        "pattern": "^[0-9]{12}$"
      },
      "children": []
    },
    {
      "path": "sign_in.aws_sign_in.allowed_principals",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Allowed principals",
      "help": "settings.sign_in.aws_sign_in.allowed_principals",
      "widget": null,
      "default": [
        "permission-set/*"
      ],
      "required": true,
      "description": "When non-empty, only principals matching one of these may sign in.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 100,
      "unique_items": true,
      "items": {
        "description": "`role/<name>`, `permission-set/<name>`, `user/<name>` or `federated-user/<name>`; `*` matches any run of characters.",
        "type": "string",
        "pattern": "^(role|permission-set|user|federated-user)/[A-Za-z0-9+=,.@_*-]{1,128}$"
      },
      "children": []
    },
    {
      "path": "sign_in.aws_sign_in.team_mappings",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Team mappings",
      "help": "settings.sign_in.aws_sign_in.team_mappings",
      "widget": null,
      "default": [],
      "required": true,
      "description": "Derived from `identity.team_rules` (proxy admin REQ-102); kept for older proxies.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": true,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 200,
      "unique_items": false,
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "match",
          "teamExternalId"
        ],
        "properties": {
          "match": {
            "$ref": "#/$defs/awsPrincipalPattern"
          },
          "teamExternalId": {
            "$ref": "#/$defs/teamExternalId"
          }
        }
      },
      "children": []
    },
    {
      "path": "sign_in.key_policy",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Key policy",
      "help": "settings.sign_in.key_policy",
      "widget": null,
      "default": null,
      "required": true,
      "description": "The policy of keys minted on the proxy (settings parity REQ-063, proxy sign-in ADR-086).",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "sign_in.key_policy.lifetime_days",
        "sign_in.key_policy.idle_days",
        "sign_in.key_policy.max_per_person"
      ]
    },
    {
      "path": "sign_in.key_policy.lifetime_days",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "integer"
      ],
      "label": "Lifetime days",
      "help": "settings.sign_in.key_policy.lifetime_days",
      "widget": null,
      "default": 0,
      "required": true,
      "description": "Days a minted key lives; 0 = it does not expire.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": 0,
      "maximum": 3650,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "sign_in.key_policy.idle_days",
      "section": "sign_in",
      "owner": "settings-parity",
      "type": [
        "integer"
      ],
      "label": "Idle days",
      "help": "settings.sign_in.key_policy.idle_days",
      "widget": null,
      "default": 0,
      "required": true,
      "description": "Days of disuse after which a key is refused and revoked; 0 = never idle.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": 0,
      "maximum": 365,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "sign_in.key_policy.max_per_person",
      "section": "sign_in",
      "owner": "proxy-sign-in",
      "type": [
        "integer"
      ],
      "label": "Max per person",
      "help": "settings.sign_in.key_policy.max_per_person",
      "widget": null,
      "default": 10,
      "required": true,
      "description": "Live keys a person may hold, one per device. Admin-issued keys don't count. At the limit a mint is refused with 409 `key_limit`.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": 1,
      "maximum": 50,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "sign_in.trusted_tokens",
      "section": "sign_in",
      "owner": "proxy-sign-in",
      "type": [
        "array"
      ],
      "label": "Trusted tokens",
      "help": "settings.sign_in.trusted_tokens",
      "widget": null,
      "default": [],
      "required": true,
      "description": "Third-party JWT issuers the proxy trusts (REQ-164). A trusted token is never a button on `/login`. `oidcProviders` in `proxy.config` is derived from the entries whose `mode` is `direct` or `both`.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 20,
      "unique_items": false,
      "items": {
        "description": "A trusted JWT issuer (ADR-092, NFR-056). People it signs in get the external id `<first 16 hex chars of sha256(canonical issuer)>:<sub>`, or resolve to the SSO person whose verified email the token carries.",
        "type": "object",
        "additionalProperties": false,
        "required": [
          "id",
          "label",
          "issuer",
          "jwks_uri",
          "audiences",
          "algorithms",
          "subject_claim",
          "email_claim",
          "groups_claim",
          "allowed_subjects",
          "max_token_life_seconds",
          "mode",
          "internal"
        ],
        "properties": {
          "id": {
            "$ref": "#/$defs/providerId"
          },
          "label": {
            "type": "string",
            "minLength": 1,
            "maxLength": 64,
            "default": "Trusted token"
          },
          "issuer": {
            "description": "Compared exactly with the token's `iss`, after canonicalisation (lower-case scheme and host, no trailing slash).",
            "$ref": "#/$defs/httpsUrl"
          },
          "jwks_uri": {
            "description": "HTTPS only; redirects to another host are refused.",
            "$ref": "#/$defs/httpsUrl"
          },
          "audiences": {
            "description": "The token's `aud` must be one of these.",
            "type": "array",
            "minItems": 1,
            "maxItems": 20,
            "uniqueItems": true,
            "items": {
              "type": "string",
              "minLength": 1,
              "maxLength": 256
            }
          },
          "algorithms": {
            "description": "The `alg` values accepted. Asymmetric only: `none` and the HMAC algorithms can never be allowed.",
            "type": "array",
            "minItems": 1,
            "maxItems": 10,
            "uniqueItems": true,
            "default": [
              "RS256"
            ],
            "items": {
              "type": "string",
              "enum": [
                "RS256",
                "RS384",
                "RS512",
                "ES256",
                "ES384",
                "ES512",
                "PS256",
                "PS384",
                "PS512",
                "EdDSA"
              ]
            }
          },
          "subject_claim": {
            "type": "string",
            "pattern": "^[A-Za-z0-9_.:/-]{1,128}$",
            "default": "sub"
          },
          "email_claim": {
            "description": "`null` when the issuer sends no email.",
            "type": [
              "string",
              "null"
            ],
            "pattern": "^[A-Za-z0-9_.:/-]{1,128}$",
            "default": "email"
          },
          "groups_claim": {
            "description": "`null` when the issuer sends no groups.",
            "type": [
              "string",
              "null"
            ],
            "pattern": "^[A-Za-z0-9_.:/-]{1,128}$",
            "default": null
          },
          "allowed_subjects": {
            "description": "When non-empty, only these subjects are admitted; `*` is a wildcard.",
            "type": "array",
            "maxItems": 500,
            "uniqueItems": true,
            "default": [],
            "items": {
              "type": "string",
              "minLength": 1,
              "maxLength": 183
            }
          },
          "max_token_life_seconds": {
            "description": "A token whose `exp` is further than this after its `iat` (or after now) is refused.",
            "type": "integer",
            "minimum": 60,
            "maximum": 86400,
            "default": 3600
          },
          "mode": {
            "description": "`direct`: the token is a bearer on the model routes (today's `oidc` mode). `exchange`: `POST /auth/token` trades it, once, for a revocable machine key. `both` allows either.",
            "type": "string",
            "enum": [
              "direct",
              "exchange",
              "both"
            ],
            "default": "exchange"
          },
          "internal": {
            "description": "The issuer may resolve to a private address; otherwise private, link-local and metadata addresses are refused.",
            "type": "boolean",
            "default": false
          }
        }
      },
      "children": []
    },
    {
      "path": "identity",
      "section": "identity",
      "owner": "proxy-admin",
      "type": [
        "object"
      ],
      "label": "Identity",
      "help": "settings.identity",
      "widget": null,
      "default": null,
      "required": true,
      "description": "Team placement and onboarding for every sign-in method (proxy admin REQ-102, REQ-104). Org default only: an installation override of it is refused (422 `org_only`).",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "org",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "identity.team_rules",
        "identity.default_team",
        "identity.capture_attributes",
        "identity.onboarding_mode"
      ]
    },
    {
      "path": "identity.team_rules",
      "section": "identity",
      "owner": "proxy-admin",
      "type": [
        "array"
      ],
      "label": "Team rules",
      "help": "settings.identity.team_rules",
      "widget": null,
      "default": [],
      "required": true,
      "description": "Tried in order after the admin pin; the first match places the person.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "org",
      "iac": "identity_team_rules_json",
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 200,
      "unique_items": false,
      "items": {
        "description": "Exactly one of `team` and `team_from_value` names the team; the settings validator enforces it.",
        "type": "object",
        "additionalProperties": false,
        "required": [
          "match"
        ],
        "properties": {
          "match": {
            "$ref": "#/$defs/identityMatcher"
          },
          "via": {
            "description": "Only for this method: `sso:<provider id>`, `iam`, `cognito`, `aws` or `oidc`.",
            "type": [
              "string",
              "null"
            ],
            "pattern": "^(sso:[a-z2-7]{12}|iam|cognito|aws|oidc)$",
            "default": null
          },
          "team": {
            "description": "The external id of an existing team.",
            "type": [
              "string",
              "null"
            ],
            "minLength": 1,
            "maxLength": 200,
            "default": null
          },
          "team_from_value": {
            "description": "The team named by the matched value, created on first use.",
            "type": "boolean",
            "default": false
          }
        }
      },
      "children": []
    },
    {
      "path": "identity.default_team",
      "section": "identity",
      "owner": "proxy-admin",
      "type": [
        "string",
        "null"
      ],
      "label": "Default team",
      "help": "settings.identity.default_team",
      "widget": null,
      "default": null,
      "required": true,
      "description": "The external id of the team for a person no rule places; `null` leaves the team unchanged.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "org",
      "iac": "identity_default_team",
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": 1,
      "max_length": 200,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "identity.capture_attributes",
      "section": "identity",
      "owner": "proxy-admin",
      "type": [
        "array"
      ],
      "label": "Capture attributes",
      "help": "settings.identity.capture_attributes",
      "widget": null,
      "default": [],
      "required": true,
      "description": "IdP attributes kept with the person's facts, for `attr:` rules.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "org",
      "iac": "identity_capture_attributes",
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 5,
      "unique_items": true,
      "items": {
        "type": "string",
        "pattern": "^[A-Za-z0-9_.:-]{1,64}$"
      },
      "children": []
    },
    {
      "path": "identity.onboarding_mode",
      "section": "identity",
      "owner": "proxy-admin",
      "type": [
        "string"
      ],
      "label": "Onboarding mode",
      "help": "settings.identity.onboarding_mode",
      "widget": null,
      "default": "open",
      "required": true,
      "description": "`approval` holds a first sign-in `pending` until an admin approves it.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "org",
      "iac": "identity_onboarding_mode",
      "env": null,
      "enum": [
        "open",
        "approval"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "admin_access",
      "section": "admin_access",
      "owner": "proxy-admin",
      "type": [
        "object"
      ],
      "label": "Admin access",
      "help": "settings.admin_access",
      "widget": null,
      "default": null,
      "required": true,
      "description": "Who is a customer admin besides holders of the `proxy_admin` grant (proxy admin REQ-096). Org default only.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "org",
      "iac": "admin_access_json",
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "admin_access.teams",
        "admin_access.match",
        "admin_access.default_admins"
      ]
    },
    {
      "path": "admin_access.teams",
      "section": "admin_access",
      "owner": "proxy-admin",
      "type": [
        "array"
      ],
      "label": "Teams",
      "help": "settings.admin_access.teams",
      "widget": null,
      "default": [],
      "required": true,
      "description": "Members of these teams (external ids) are admins.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "org",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 100,
      "unique_items": true,
      "items": {
        "type": "string",
        "minLength": 1,
        "maxLength": 200
      },
      "children": []
    },
    {
      "path": "admin_access.match",
      "section": "admin_access",
      "owner": "proxy-admin",
      "type": [
        "array"
      ],
      "label": "Match",
      "help": "settings.admin_access.match",
      "widget": null,
      "default": [],
      "required": true,
      "description": "People whose facts match one of these are admins. A bare `*` is refused.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "org",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 100,
      "unique_items": true,
      "items": {
        "description": "Proxy admin's matcher grammar (REQ-102): `group:`, `attr:<name>=`, `email:`, `role/`, `permission-set/`, `user/`, `federated-user/`, `account/` or `iam-group/`, then a value in which `*` is a wildcard.",
        "type": "string",
        "maxLength": 512,
        "pattern": "^(group:|attr:[A-Za-z0-9_.:-]{1,64}=|email:|role/|permission-set/|user/|federated-user/|account/|iam-group/).{1,448}$"
      },
      "children": []
    },
    {
      "path": "admin_access.default_admins",
      "section": "admin_access",
      "owner": "proxy-admin",
      "type": [
        "array"
      ],
      "label": "Default admins",
      "help": "settings.admin_access.default_admins",
      "widget": null,
      "default": [
        "chad.grant@allcode.com",
        "joel@allcode.com",
        "andreas@allcode.com"
      ],
      "required": true,
      "description": "People who sign in with one of these verified email addresses are admins, before any grant, team or matcher is set up. Compared without regard to case. AllCode's proxy admins are listed by default; admins add their own here.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "org",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 50,
      "unique_items": true,
      "items": {
        "description": "An email address as the key store compares one: printable ASCII with exactly one `@` and something on both sides, at most 254 characters. Letters fold to lower case on compare, so any casing may be written.",
        "type": "string",
        "maxLength": 254,
        "pattern": "^[!-?A-~]+@[!-?A-~]+$"
      },
      "children": []
    },
    {
      "path": "models",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Models",
      "help": "settings.models",
      "widget": null,
      "default": {
        "claude_code": {
          "mode": "follow_aws",
          "providers": [
            "anthropic"
          ],
          "include_new_models": true,
          "allowed": [],
          "default": "claude-opus-5-5",
          "display_names": []
        },
        "codex": {
          "mode": "follow_aws",
          "providers": [
            "openai"
          ],
          "include_new_models": true,
          "allowed": [],
          "default": "gpt-6-astra",
          "display_names": []
        },
        "other": {
          "mode": "follow_aws",
          "providers": [
            "*"
          ],
          "include_new_models": true,
          "allowed": [],
          "default": "claude-opus-5-5",
          "display_names": []
        },
        "web": {
          "mode": "follow_aws",
          "providers": [
            "anthropic",
            "openai"
          ],
          "include_new_models": true,
          "allowed": [],
          "default": "claude-opus-5-5",
          "display_names": []
        },
        "allowed_models": [
          {
            "provider": "anthropic",
            "enabled": true,
            "mode": "follow_aws",
            "allowed": []
          },
          {
            "provider": "openai",
            "enabled": true,
            "mode": "follow_aws",
            "allowed": []
          },
          {
            "provider": "*",
            "enabled": true,
            "mode": "follow_aws",
            "allowed": []
          }
        ],
        "fallbacks": []
      },
      "required": false,
      "description": "Which models each tool (harness) gets (settings parity REQ-052..057, ADR-040/041). A harness is `harness_of(platform)`: Claude Code; Codex and Codex desktop; the proxy home's chat (`web`); anything else. The effective list per harness is invokable ∩ servable ∩ `providers` ∩ selection ∩ the credential's `allowedModels`: harness policy is product policy, never an access boundary (SP-4).",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "models.claude_code",
        "models.codex",
        "models.other",
        "models.web",
        "models.allowed_models",
        "models.fallbacks"
      ]
    },
    {
      "path": "models.claude_code",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Claude Code",
      "help": "settings.models.claude_code",
      "widget": null,
      "default": {
        "mode": "follow_aws",
        "providers": [
          "anthropic"
        ],
        "include_new_models": true,
        "allowed": [],
        "default": "claude-opus-5-5",
        "display_names": []
      },
      "required": true,
      "description": "Claude Code.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "models_claude_code_json",
      "env": "NEXUS_SET_MODELS_CLAUDE_CODE",
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "models.claude_code.mode",
        "models.claude_code.providers",
        "models.claude_code.include_new_models",
        "models.claude_code.allowed",
        "models.claude_code.default",
        "models.claude_code.display_names"
      ]
    },
    {
      "path": "models.claude_code.mode",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Selection",
      "help": "settings.models.mode",
      "widget": "select",
      "default": "follow_aws",
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "follow_aws",
        "allow_list"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "models.claude_code.providers",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Providers",
      "help": "settings.models.providers",
      "widget": "provider-picker",
      "default": [
        "*"
      ],
      "required": true,
      "description": "Bedrock provider segments (`anthropic`, `openai`, `amazon`, `meta`, ...); `*` is every provider.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": 1,
      "max_items": 20,
      "unique_items": true,
      "items": {
        "description": "A Bedrock provider segment, or `*` for every provider.",
        "type": "string",
        "pattern": "^(\\*|[a-z][a-z0-9-]{0,63})$"
      },
      "children": []
    },
    {
      "path": "models.claude_code.include_new_models",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "boolean"
      ],
      "label": "Serve new models automatically",
      "help": "settings.models.include_new_models",
      "widget": "toggle",
      "default": true,
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "models.claude_code.allowed",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Allowed models",
      "help": "settings.models.allowed",
      "widget": "model-picker",
      "default": [],
      "required": true,
      "description": "Family names (`claude-opus-5-5`, `gpt-6-astra`), as `/v1/models` lists them.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 200,
      "unique_items": true,
      "items": {
        "description": "A model's family name as the proxy serves it: lower-case, dots, dashes and the colon of a Bedrock model id (`amazon.nova-pro-v1:0` is served under its id).",
        "type": "string",
        "pattern": "^[a-z0-9][a-z0-9.:-]{0,127}$"
      },
      "children": []
    },
    {
      "path": "models.claude_code.default",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Default model",
      "help": "settings.models.default",
      "widget": "model-picker",
      "default": "claude-opus-5-5",
      "required": true,
      "description": "Listed first by `/v1/models`; what the tool uses when it names none.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": "^[a-z0-9][a-z0-9.:-]{0,127}$",
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "models.claude_code.display_names",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Display names",
      "help": "settings.models.display_names",
      "widget": "list",
      "default": [],
      "required": true,
      "description": "What `/v1/models` shows for a model, by family name; routing is unchanged. A list of pairs rather than a map because the keyword subset has no `patternProperties`.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 200,
      "unique_items": false,
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "model",
          "name"
        ],
        "properties": {
          "model": {
            "$ref": "#/$defs/modelName"
          },
          "name": {
            "type": "string",
            "minLength": 1,
            "maxLength": 64
          }
        }
      },
      "children": []
    },
    {
      "path": "models.codex",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Codex",
      "help": "settings.models.codex",
      "widget": null,
      "default": {
        "mode": "follow_aws",
        "providers": [
          "openai"
        ],
        "include_new_models": true,
        "allowed": [],
        "default": "gpt-6-astra",
        "display_names": []
      },
      "required": true,
      "description": "Codex and Codex desktop.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "models_codex_json",
      "env": "NEXUS_SET_MODELS_CODEX",
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "models.codex.mode",
        "models.codex.providers",
        "models.codex.include_new_models",
        "models.codex.allowed",
        "models.codex.default",
        "models.codex.display_names"
      ]
    },
    {
      "path": "models.codex.mode",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Selection",
      "help": "settings.models.mode",
      "widget": "select",
      "default": "follow_aws",
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "follow_aws",
        "allow_list"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "models.codex.providers",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Providers",
      "help": "settings.models.providers",
      "widget": "provider-picker",
      "default": [
        "*"
      ],
      "required": true,
      "description": "Bedrock provider segments (`anthropic`, `openai`, `amazon`, `meta`, ...); `*` is every provider.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": 1,
      "max_items": 20,
      "unique_items": true,
      "items": {
        "description": "A Bedrock provider segment, or `*` for every provider.",
        "type": "string",
        "pattern": "^(\\*|[a-z][a-z0-9-]{0,63})$"
      },
      "children": []
    },
    {
      "path": "models.codex.include_new_models",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "boolean"
      ],
      "label": "Serve new models automatically",
      "help": "settings.models.include_new_models",
      "widget": "toggle",
      "default": true,
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "models.codex.allowed",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Allowed models",
      "help": "settings.models.allowed",
      "widget": "model-picker",
      "default": [],
      "required": true,
      "description": "Family names (`claude-opus-5-5`, `gpt-6-astra`), as `/v1/models` lists them.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 200,
      "unique_items": true,
      "items": {
        "description": "A model's family name as the proxy serves it: lower-case, dots, dashes and the colon of a Bedrock model id (`amazon.nova-pro-v1:0` is served under its id).",
        "type": "string",
        "pattern": "^[a-z0-9][a-z0-9.:-]{0,127}$"
      },
      "children": []
    },
    {
      "path": "models.codex.default",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Default model",
      "help": "settings.models.default",
      "widget": "model-picker",
      "default": "claude-opus-5-5",
      "required": true,
      "description": "Listed first by `/v1/models`; what the tool uses when it names none.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": "^[a-z0-9][a-z0-9.:-]{0,127}$",
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "models.codex.display_names",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Display names",
      "help": "settings.models.display_names",
      "widget": "list",
      "default": [],
      "required": true,
      "description": "What `/v1/models` shows for a model, by family name; routing is unchanged. A list of pairs rather than a map because the keyword subset has no `patternProperties`.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 200,
      "unique_items": false,
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "model",
          "name"
        ],
        "properties": {
          "model": {
            "$ref": "#/$defs/modelName"
          },
          "name": {
            "type": "string",
            "minLength": 1,
            "maxLength": 64
          }
        }
      },
      "children": []
    },
    {
      "path": "models.other",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Other tools",
      "help": "settings.models.other",
      "widget": null,
      "default": {
        "mode": "follow_aws",
        "providers": [
          "*"
        ],
        "include_new_models": true,
        "allowed": [],
        "default": "claude-opus-5-5",
        "display_names": []
      },
      "required": true,
      "description": "Every other client: Claude desktop, Cursor, unknown user agents.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "models_other_json",
      "env": "NEXUS_SET_MODELS_OTHER",
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "models.other.mode",
        "models.other.providers",
        "models.other.include_new_models",
        "models.other.allowed",
        "models.other.default",
        "models.other.display_names"
      ]
    },
    {
      "path": "models.other.mode",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Selection",
      "help": "settings.models.mode",
      "widget": "select",
      "default": "follow_aws",
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "follow_aws",
        "allow_list"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "models.other.providers",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Providers",
      "help": "settings.models.providers",
      "widget": "provider-picker",
      "default": [
        "*"
      ],
      "required": true,
      "description": "Bedrock provider segments (`anthropic`, `openai`, `amazon`, `meta`, ...); `*` is every provider.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": 1,
      "max_items": 20,
      "unique_items": true,
      "items": {
        "description": "A Bedrock provider segment, or `*` for every provider.",
        "type": "string",
        "pattern": "^(\\*|[a-z][a-z0-9-]{0,63})$"
      },
      "children": []
    },
    {
      "path": "models.other.include_new_models",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "boolean"
      ],
      "label": "Serve new models automatically",
      "help": "settings.models.include_new_models",
      "widget": "toggle",
      "default": true,
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "models.other.allowed",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Allowed models",
      "help": "settings.models.allowed",
      "widget": "model-picker",
      "default": [],
      "required": true,
      "description": "Family names (`claude-opus-5-5`, `gpt-6-astra`), as `/v1/models` lists them.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 200,
      "unique_items": true,
      "items": {
        "description": "A model's family name as the proxy serves it: lower-case, dots, dashes and the colon of a Bedrock model id (`amazon.nova-pro-v1:0` is served under its id).",
        "type": "string",
        "pattern": "^[a-z0-9][a-z0-9.:-]{0,127}$"
      },
      "children": []
    },
    {
      "path": "models.other.default",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Default model",
      "help": "settings.models.default",
      "widget": "model-picker",
      "default": "claude-opus-5-5",
      "required": true,
      "description": "Listed first by `/v1/models`; what the tool uses when it names none.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": "^[a-z0-9][a-z0-9.:-]{0,127}$",
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "models.other.display_names",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Display names",
      "help": "settings.models.display_names",
      "widget": "list",
      "default": [],
      "required": true,
      "description": "What `/v1/models` shows for a model, by family name; routing is unchanged. A list of pairs rather than a map because the keyword subset has no `patternProperties`.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 200,
      "unique_items": false,
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "model",
          "name"
        ],
        "properties": {
          "model": {
            "$ref": "#/$defs/modelName"
          },
          "name": {
            "type": "string",
            "minLength": 1,
            "maxLength": 64
          }
        }
      },
      "children": []
    },
    {
      "path": "models.web",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Web chat",
      "help": "settings.models.web",
      "widget": null,
      "default": {
        "mode": "follow_aws",
        "providers": [
          "anthropic",
          "openai"
        ],
        "include_new_models": true,
        "allowed": [],
        "default": "claude-opus-5-5",
        "display_names": []
      },
      "required": true,
      "description": "The proxy home's chat (platform `web`). Named on its own rather than left to `other`, as `tool_access.DEFAULT_PLATFORM_PROVIDERS` does, so narrowing `other` cannot silently take the chat's models away.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "models_web_json",
      "env": "NEXUS_SET_MODELS_WEB",
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "models.web.mode",
        "models.web.providers",
        "models.web.include_new_models",
        "models.web.allowed",
        "models.web.default",
        "models.web.display_names"
      ]
    },
    {
      "path": "models.web.mode",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Selection",
      "help": "settings.models.mode",
      "widget": "select",
      "default": "follow_aws",
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "follow_aws",
        "allow_list"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "models.web.providers",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Providers",
      "help": "settings.models.providers",
      "widget": "provider-picker",
      "default": [
        "*"
      ],
      "required": true,
      "description": "Bedrock provider segments (`anthropic`, `openai`, `amazon`, `meta`, ...); `*` is every provider.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": 1,
      "max_items": 20,
      "unique_items": true,
      "items": {
        "description": "A Bedrock provider segment, or `*` for every provider.",
        "type": "string",
        "pattern": "^(\\*|[a-z][a-z0-9-]{0,63})$"
      },
      "children": []
    },
    {
      "path": "models.web.include_new_models",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "boolean"
      ],
      "label": "Serve new models automatically",
      "help": "settings.models.include_new_models",
      "widget": "toggle",
      "default": true,
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "models.web.allowed",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Allowed models",
      "help": "settings.models.allowed",
      "widget": "model-picker",
      "default": [],
      "required": true,
      "description": "Family names (`claude-opus-5-5`, `gpt-6-astra`), as `/v1/models` lists them.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 200,
      "unique_items": true,
      "items": {
        "description": "A model's family name as the proxy serves it: lower-case, dots, dashes and the colon of a Bedrock model id (`amazon.nova-pro-v1:0` is served under its id).",
        "type": "string",
        "pattern": "^[a-z0-9][a-z0-9.:-]{0,127}$"
      },
      "children": []
    },
    {
      "path": "models.web.default",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Default model",
      "help": "settings.models.default",
      "widget": "model-picker",
      "default": "claude-opus-5-5",
      "required": true,
      "description": "Listed first by `/v1/models`; what the tool uses when it names none.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": "^[a-z0-9][a-z0-9.:-]{0,127}$",
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "models.web.display_names",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Display names",
      "help": "settings.models.display_names",
      "widget": "list",
      "default": [],
      "required": true,
      "description": "What `/v1/models` shows for a model, by family name; routing is unchanged. A list of pairs rather than a map because the keyword subset has no `patternProperties`.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 200,
      "unique_items": false,
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "model",
          "name"
        ],
        "properties": {
          "model": {
            "$ref": "#/$defs/modelName"
          },
          "name": {
            "type": "string",
            "minLength": 1,
            "maxLength": 64
          }
        }
      },
      "children": []
    },
    {
      "path": "models.allowed_models",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Allowed models by provider",
      "help": "settings.models.allowed_models",
      "widget": "provider-models",
      "default": [
        {
          "provider": "anthropic",
          "enabled": true,
          "mode": "follow_aws",
          "allowed": []
        },
        {
          "provider": "openai",
          "enabled": true,
          "mode": "follow_aws",
          "allowed": []
        },
        {
          "provider": "*",
          "enabled": true,
          "mode": "follow_aws",
          "allowed": []
        }
      ],
      "required": false,
      "description": "The org's one list of allowed models, per provider (ADR-103): every agent's effective list and default are drawn from it, and a harness policy may only narrow it. A provider with `enabled` false offers nothing to any agent; `follow_aws` offers every invokable model of the provider, `allow_list` exactly `allowed`; `*` is every provider no entry of its own names. One entry per provider: a second entry for the same provider is refused by the settings validator. Org default only. Absent from a document, it is the default: Anthropic, OpenAI and every other provider, each following AWS, which changes no harness's list.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "org",
      "iac": "models_allowed_models_json",
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 20,
      "unique_items": true,
      "items": {
        "description": "One provider's entry in `models.allowed_models`. `follow_aws` allows every model of the provider AWS makes invokable (whether a harness serves a model that appears later is still that harness's `include_new_models`); `allow_list` allows exactly `allowed`, family names as `/v1/models` lists them.",
        "type": "object",
        "additionalProperties": false,
        "required": [
          "provider",
          "enabled",
          "mode",
          "allowed"
        ],
        "properties": {
          "provider": {
            "$ref": "#/$defs/providerSegment"
          },
          "enabled": {
            "type": "boolean",
            "default": true
          },
          "mode": {
            "type": "string",
            "enum": [
              "follow_aws",
              "allow_list"
            ],
            "default": "follow_aws"
          },
          "allowed": {
            "type": "array",
            "maxItems": 200,
            "uniqueItems": true,
            "default": [],
            "items": {
              "$ref": "#/$defs/modelName"
            }
          }
        }
      },
      "children": []
    },
    {
      "path": "models.fallbacks",
      "section": "models",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Fallbacks",
      "help": "settings.models.fallbacks",
      "widget": "model-fallbacks",
      "default": [],
      "required": false,
      "description": "Models the proxy tries, in order, when Bedrock cannot serve a model for capacity (FALLBACK-1): HTTP 503 `ServiceUnavailableException` or \"unable to process\", or 429 `ThrottlingException`, answered before the first byte of the response. Never on a validation error, an access denial or a guardrail block, and never once a stream has started. Each retry is checked like a new request (the model allowed for the agent, the guardrail, the quota), the usage event records the model that served it with `fallbackFrom` naming the one that failed, and the fallback model starts with a cold prompt cache. One entry per `from` model; `to` holds one to three models, never `from` itself or a repeat, each allowed by `allowed_models` for every agent that can use `from` (the settings validator refuses anything else, 422 `fallback_not_allowed`). Org default only. Empty, the default, is no fallback.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "org",
      "iac": "models_fallbacks_json",
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 50,
      "unique_items": true,
      "items": {
        "description": "One entry of `models.fallbacks`: when `from` is unavailable for capacity, try each of `to` in order. Family names as `/v1/models` lists them.",
        "type": "object",
        "additionalProperties": false,
        "required": [
          "from",
          "to"
        ],
        "properties": {
          "from": {
            "$ref": "#/$defs/modelName"
          },
          "to": {
            "type": "array",
            "minItems": 1,
            "maxItems": 3,
            "uniqueItems": true,
            "items": {
              "$ref": "#/$defs/modelName"
            }
          }
        }
      },
      "children": []
    },
    {
      "path": "guardrails",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Guardrails",
      "help": "settings.guardrails",
      "widget": null,
      "default": {
        "enabled": false,
        "mode": "create",
        "existing": null,
        "definition": null,
        "apply_to": [
          "all"
        ],
        "trace": "enabled",
        "stream_processing": "sync"
      },
      "required": false,
      "description": "A Bedrock guardrail the proxy attaches to requests (settings parity REQ-064..066, ADR-044). Off by default (SP-5). Created by the IaC when `mode` is `create`; a configured guardrail that cannot be applied fails the request closed (NFR-029). Charges for guardrail use are feature 4's concern, not this document's.",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "guardrails.enabled",
        "guardrails.mode",
        "guardrails.existing",
        "guardrails.definition",
        "guardrails.apply_to",
        "guardrails.trace",
        "guardrails.stream_processing"
      ]
    },
    {
      "path": "guardrails.enabled",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "boolean"
      ],
      "label": "Apply a guardrail",
      "help": "settings.guardrails.enabled",
      "widget": "toggle",
      "default": false,
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "guardrail_enabled",
      "env": "NEXUS_SET_GUARDRAILS_ENABLED",
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.mode",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Guardrail source",
      "help": "settings.guardrails.mode",
      "widget": "select",
      "default": "create",
      "required": true,
      "description": "`create`: the IaC builds the guardrail from `definition`; `existing`: `existing` names one the account already has.",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "guardrail_mode",
      "env": "NEXUS_SET_GUARDRAILS_MODE",
      "enum": [
        "create",
        "existing"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.existing",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "object",
        "null"
      ],
      "label": "Existing guardrail",
      "help": "settings.guardrails.existing",
      "widget": null,
      "default": null,
      "required": true,
      "description": "The id and version of an existing guardrail; `null` unless `mode` is `existing`.",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "guardrail_existing_json",
      "env": "NEXUS_SET_GUARDRAILS_EXISTING",
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "guardrails.existing.id",
        "guardrails.existing.version"
      ]
    },
    {
      "path": "guardrails.existing.id",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Id",
      "help": "settings.guardrails.existing.id",
      "widget": null,
      "default": null,
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": "^[a-z0-9]{12}$",
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.existing.version",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Version",
      "help": "settings.guardrails.existing.version",
      "widget": null,
      "default": null,
      "required": true,
      "description": "A numbered version or `DRAFT`.",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": "^([1-9][0-9]{0,4}|DRAFT)$",
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.definition",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "object",
        "null"
      ],
      "label": "Guardrail definition",
      "help": "settings.guardrails.definition",
      "widget": "json",
      "default": null,
      "required": true,
      "description": "What the IaC creates when `mode` is `create`; `null` otherwise.",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "guardrail_definition_json",
      "env": "NEXUS_SET_GUARDRAILS_DEFINITION",
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "guardrails.definition.content_filters",
        "guardrails.definition.denied_topics",
        "guardrails.definition.word_filters",
        "guardrails.definition.sensitive_information",
        "guardrails.definition.contextual_grounding",
        "guardrails.definition.blocked_input_message",
        "guardrails.definition.blocked_output_message"
      ]
    },
    {
      "path": "guardrails.definition.content_filters",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Content filters",
      "help": "settings.guardrails.definition.content_filters",
      "widget": null,
      "default": null,
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "guardrails.definition.content_filters.hate",
        "guardrails.definition.content_filters.insults",
        "guardrails.definition.content_filters.sexual",
        "guardrails.definition.content_filters.violence",
        "guardrails.definition.content_filters.misconduct",
        "guardrails.definition.content_filters.prompt_attack"
      ]
    },
    {
      "path": "guardrails.definition.content_filters.hate",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Hate",
      "help": "settings.guardrails.definition.content_filters.hate",
      "widget": null,
      "default": null,
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "guardrails.definition.content_filters.hate.input",
        "guardrails.definition.content_filters.hate.output"
      ]
    },
    {
      "path": "guardrails.definition.content_filters.hate.input",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Input",
      "help": "settings.guardrails.definition.content_filters.hate.input",
      "widget": null,
      "default": "HIGH",
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "NONE",
        "LOW",
        "MEDIUM",
        "HIGH"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.definition.content_filters.hate.output",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Output",
      "help": "settings.guardrails.definition.content_filters.hate.output",
      "widget": null,
      "default": "HIGH",
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "NONE",
        "LOW",
        "MEDIUM",
        "HIGH"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.definition.content_filters.insults",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Insults",
      "help": "settings.guardrails.definition.content_filters.insults",
      "widget": null,
      "default": null,
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "guardrails.definition.content_filters.insults.input",
        "guardrails.definition.content_filters.insults.output"
      ]
    },
    {
      "path": "guardrails.definition.content_filters.insults.input",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Input",
      "help": "settings.guardrails.definition.content_filters.insults.input",
      "widget": null,
      "default": "HIGH",
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "NONE",
        "LOW",
        "MEDIUM",
        "HIGH"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.definition.content_filters.insults.output",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Output",
      "help": "settings.guardrails.definition.content_filters.insults.output",
      "widget": null,
      "default": "HIGH",
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "NONE",
        "LOW",
        "MEDIUM",
        "HIGH"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.definition.content_filters.sexual",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Sexual",
      "help": "settings.guardrails.definition.content_filters.sexual",
      "widget": null,
      "default": null,
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "guardrails.definition.content_filters.sexual.input",
        "guardrails.definition.content_filters.sexual.output"
      ]
    },
    {
      "path": "guardrails.definition.content_filters.sexual.input",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Input",
      "help": "settings.guardrails.definition.content_filters.sexual.input",
      "widget": null,
      "default": "HIGH",
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "NONE",
        "LOW",
        "MEDIUM",
        "HIGH"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.definition.content_filters.sexual.output",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Output",
      "help": "settings.guardrails.definition.content_filters.sexual.output",
      "widget": null,
      "default": "HIGH",
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "NONE",
        "LOW",
        "MEDIUM",
        "HIGH"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.definition.content_filters.violence",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Violence",
      "help": "settings.guardrails.definition.content_filters.violence",
      "widget": null,
      "default": null,
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "guardrails.definition.content_filters.violence.input",
        "guardrails.definition.content_filters.violence.output"
      ]
    },
    {
      "path": "guardrails.definition.content_filters.violence.input",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Input",
      "help": "settings.guardrails.definition.content_filters.violence.input",
      "widget": null,
      "default": "HIGH",
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "NONE",
        "LOW",
        "MEDIUM",
        "HIGH"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.definition.content_filters.violence.output",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Output",
      "help": "settings.guardrails.definition.content_filters.violence.output",
      "widget": null,
      "default": "HIGH",
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "NONE",
        "LOW",
        "MEDIUM",
        "HIGH"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.definition.content_filters.misconduct",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Misconduct",
      "help": "settings.guardrails.definition.content_filters.misconduct",
      "widget": null,
      "default": null,
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "guardrails.definition.content_filters.misconduct.input",
        "guardrails.definition.content_filters.misconduct.output"
      ]
    },
    {
      "path": "guardrails.definition.content_filters.misconduct.input",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Input",
      "help": "settings.guardrails.definition.content_filters.misconduct.input",
      "widget": null,
      "default": "HIGH",
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "NONE",
        "LOW",
        "MEDIUM",
        "HIGH"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.definition.content_filters.misconduct.output",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Output",
      "help": "settings.guardrails.definition.content_filters.misconduct.output",
      "widget": null,
      "default": "HIGH",
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "NONE",
        "LOW",
        "MEDIUM",
        "HIGH"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.definition.content_filters.prompt_attack",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Prompt attack",
      "help": "settings.guardrails.definition.content_filters.prompt_attack",
      "widget": null,
      "default": null,
      "required": true,
      "description": "Input only: Bedrock requires the output strength `NONE`.",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "guardrails.definition.content_filters.prompt_attack.input"
      ]
    },
    {
      "path": "guardrails.definition.content_filters.prompt_attack.input",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Input",
      "help": "settings.guardrails.definition.content_filters.prompt_attack.input",
      "widget": null,
      "default": "HIGH",
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": [
        "NONE",
        "LOW",
        "MEDIUM",
        "HIGH"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.definition.denied_topics",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Denied topics",
      "help": "settings.guardrails.definition.denied_topics",
      "widget": null,
      "default": [],
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 30,
      "unique_items": false,
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "name",
          "definition",
          "examples"
        ],
        "properties": {
          "name": {
            "type": "string",
            "pattern": "^[0-9a-zA-Z\\-_ !?.]{1,100}$"
          },
          "definition": {
            "type": "string",
            "minLength": 1,
            "maxLength": 200
          },
          "examples": {
            "type": "array",
            "maxItems": 5,
            "default": [],
            "items": {
              "type": "string",
              "minLength": 1,
              "maxLength": 100
            }
          }
        }
      },
      "children": []
    },
    {
      "path": "guardrails.definition.word_filters",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Word filters",
      "help": "settings.guardrails.definition.word_filters",
      "widget": null,
      "default": null,
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "guardrails.definition.word_filters.profanity",
        "guardrails.definition.word_filters.words"
      ]
    },
    {
      "path": "guardrails.definition.word_filters.profanity",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "boolean"
      ],
      "label": "Profanity",
      "help": "settings.guardrails.definition.word_filters.profanity",
      "widget": null,
      "default": false,
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.definition.word_filters.words",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Words",
      "help": "settings.guardrails.definition.word_filters.words",
      "widget": null,
      "default": [],
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 10000,
      "unique_items": true,
      "items": {
        "type": "string",
        "minLength": 1,
        "maxLength": 100
      },
      "children": []
    },
    {
      "path": "guardrails.definition.sensitive_information",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Sensitive information",
      "help": "settings.guardrails.definition.sensitive_information",
      "widget": null,
      "default": null,
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "guardrails.definition.sensitive_information.pii_entities",
        "guardrails.definition.sensitive_information.regexes"
      ]
    },
    {
      "path": "guardrails.definition.sensitive_information.pii_entities",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Pii entities",
      "help": "settings.guardrails.definition.sensitive_information.pii_entities",
      "widget": null,
      "default": [],
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 50,
      "unique_items": false,
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "type",
          "action"
        ],
        "properties": {
          "type": {
            "description": "A Bedrock PII entity type, e.g. `EMAIL`, `US_SOCIAL_SECURITY_NUMBER`.",
            "type": "string",
            "pattern": "^[A-Z][A-Z0-9_]{1,63}$"
          },
          "action": {
            "$ref": "#/$defs/piiAction"
          }
        }
      },
      "children": []
    },
    {
      "path": "guardrails.definition.sensitive_information.regexes",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Regexes",
      "help": "settings.guardrails.definition.sensitive_information.regexes",
      "widget": null,
      "default": [],
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 10,
      "unique_items": false,
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "name",
          "pattern",
          "action"
        ],
        "properties": {
          "name": {
            "type": "string",
            "minLength": 1,
            "maxLength": 100
          },
          "pattern": {
            "type": "string",
            "minLength": 1,
            "maxLength": 500
          },
          "action": {
            "$ref": "#/$defs/piiAction"
          }
        }
      },
      "children": []
    },
    {
      "path": "guardrails.definition.contextual_grounding",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Contextual grounding",
      "help": "settings.guardrails.definition.contextual_grounding",
      "widget": null,
      "default": null,
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "guardrails.definition.contextual_grounding.grounding",
        "guardrails.definition.contextual_grounding.relevance"
      ]
    },
    {
      "path": "guardrails.definition.contextual_grounding.grounding",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "number",
        "null"
      ],
      "label": "Grounding",
      "help": "settings.guardrails.definition.contextual_grounding.grounding",
      "widget": null,
      "default": null,
      "required": true,
      "description": "`null` leaves the check off; otherwise a confidence threshold below 1.",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": 0,
      "maximum": 0.99,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.definition.contextual_grounding.relevance",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "number",
        "null"
      ],
      "label": "Relevance",
      "help": "settings.guardrails.definition.contextual_grounding.relevance",
      "widget": null,
      "default": null,
      "required": true,
      "description": "`null` leaves the check off; otherwise a confidence threshold below 1.",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": 0,
      "maximum": 0.99,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.definition.blocked_input_message",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Blocked input message",
      "help": "settings.guardrails.definition.blocked_input_message",
      "widget": null,
      "default": "Your request was blocked by your organization's content policy.",
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": 1,
      "max_length": 500,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.definition.blocked_output_message",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Blocked output message",
      "help": "settings.guardrails.definition.blocked_output_message",
      "widget": null,
      "default": "The response was blocked by your organization's content policy.",
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": 1,
      "max_length": 500,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.apply_to",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "array"
      ],
      "label": "Apply to",
      "help": "settings.guardrails.apply_to",
      "widget": "multiselect",
      "default": [
        "all"
      ],
      "required": true,
      "description": "The harnesses whose requests carry the guardrail; `all` means every one.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "guardrail_apply_to",
      "env": "NEXUS_SET_GUARDRAILS_APPLY_TO",
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": 1,
      "max_items": 5,
      "unique_items": true,
      "items": {
        "type": "string",
        "enum": [
          "all",
          "claude_code",
          "codex",
          "other",
          "web"
        ]
      },
      "children": []
    },
    {
      "path": "guardrails.trace",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Trace",
      "help": "settings.guardrails.trace",
      "widget": "select",
      "default": "enabled",
      "required": true,
      "description": "Whether Bedrock returns the guardrail's assessment with each response (`enabled_full` includes the matched text; the usage event never records it).",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "guardrail_trace",
      "env": "NEXUS_SET_GUARDRAILS_TRACE",
      "enum": [
        "disabled",
        "enabled",
        "enabled_full"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "guardrails.stream_processing",
      "section": "guardrails",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Streaming mode",
      "help": "settings.guardrails.stream_processing",
      "widget": "select",
      "default": "sync",
      "required": true,
      "description": "Bedrock's `streamProcessingMode`: `sync` holds each chunk until it is assessed; `async` lets text through and blocks on a later assessment.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "guardrail_stream_processing",
      "env": "NEXUS_SET_GUARDRAILS_STREAM_PROCESSING",
      "enum": [
        "sync",
        "async"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "upstreams",
      "section": "upstreams",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Upstreams",
      "help": "settings.upstreams",
      "widget": null,
      "default": {
        "bedrock": {
          "enabled": true
        }
      },
      "required": false,
      "description": "The model providers behind the proxy. Bedrock is the only one; a later feature adds another as a new top-level section with its own owner, without a schema version change.",
      "apply": "live",
      "customer_editable": false,
      "customer_readonly": false,
      "staff_only": true,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "upstreams.bedrock"
      ]
    },
    {
      "path": "upstreams.bedrock",
      "section": "upstreams",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Bedrock",
      "help": "settings.upstreams.bedrock",
      "widget": null,
      "default": null,
      "required": true,
      "description": "",
      "apply": "live",
      "customer_editable": false,
      "customer_readonly": false,
      "staff_only": true,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "upstreams.bedrock.enabled"
      ]
    },
    {
      "path": "upstreams.bedrock.enabled",
      "section": "upstreams",
      "owner": "settings-parity",
      "type": [
        "boolean"
      ],
      "label": "Bedrock",
      "help": "settings.upstreams.bedrock.enabled",
      "widget": "toggle",
      "default": true,
      "required": true,
      "description": "Off makes the proxy refuse every model request with 503 `upstream_disabled`; sign-in and the admin area keep working.",
      "apply": "live",
      "customer_editable": false,
      "customer_readonly": false,
      "staff_only": true,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "upstream_bedrock_enabled",
      "env": "NEXUS_SET_UPSTREAMS_BEDROCK_ENABLED",
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "org",
      "section": "org",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Org",
      "help": "settings.org",
      "widget": null,
      "default": {
        "display_name": ""
      },
      "required": false,
      "description": "Facts about the organisation the API fills in when it serves the document. Read-only everywhere: a settings write that carries a different value is refused (422 `server_generated`).",
      "apply": "live",
      "customer_editable": false,
      "customer_readonly": true,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": true,
      "deprecated": false,
      "scope": "org",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "org.display_name"
      ]
    },
    {
      "path": "org.display_name",
      "section": "org",
      "owner": "settings-parity",
      "type": [
        "string"
      ],
      "label": "Organisation",
      "help": "settings.org.display_name",
      "widget": null,
      "default": "",
      "required": true,
      "description": "The organisation's name as the admin app shows it; nexus-web's `MeResponse.OrgName` (TASK-428). Empty until the API serves the document.",
      "apply": "live",
      "customer_editable": false,
      "customer_readonly": true,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": true,
      "deprecated": false,
      "scope": "org",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": 200,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "web_search",
      "section": "web_search",
      "owner": "settings-parity",
      "type": [
        "object"
      ],
      "label": "Web search",
      "help": "settings.web_search",
      "widget": null,
      "default": {
        "provider": null,
        "secret_name": null
      },
      "required": false,
      "description": "The search provider LiteLLM runs Claude Code's web searches through (web search hotfix, 2026-09-30). Staff-only: AllCode chooses the provider and writes the key into the proxy account's Secrets Manager; the customer admin never sees these fields. `provider` `null` turns web search off.",
      "apply": "redeploy",
      "customer_editable": false,
      "customer_readonly": false,
      "staff_only": true,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "web_search.provider",
        "web_search.secret_name"
      ]
    },
    {
      "path": "web_search.provider",
      "section": "web_search",
      "owner": "settings-parity",
      "type": [
        "string",
        "null"
      ],
      "label": "Search provider",
      "help": "settings.web_search.provider",
      "widget": "select",
      "default": null,
      "required": true,
      "description": "",
      "apply": "redeploy",
      "customer_editable": false,
      "customer_readonly": false,
      "staff_only": true,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "web_search_provider",
      "env": "NEXUS_SET_WEB_SEARCH_PROVIDER",
      "enum": [
        "tavily",
        "perplexity",
        "exa_ai",
        "serper",
        "brave",
        "agentcore",
        null
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "web_search.secret_name",
      "section": "web_search",
      "owner": "settings-parity",
      "type": [
        "string",
        "null"
      ],
      "label": "API key secret",
      "help": "settings.web_search.secret_name",
      "widget": null,
      "default": null,
      "required": true,
      "description": "The Secrets Manager name of the provider's API key in the proxy account, `nexus/<installationId>/web-search`, never its value. Required when `provider` is set; the settings validator enforces the pair.",
      "apply": "redeploy",
      "customer_editable": false,
      "customer_readonly": false,
      "staff_only": true,
      "secret_ref": true,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "web_search_secret_name",
      "env": "NEXUS_SET_WEB_SEARCH_SECRET_NAME",
      "enum": null,
      "pattern": "^nexus/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/web-search$",
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "quotas",
      "section": "quotas",
      "owner": "quotas-reporting",
      "type": [
        "object"
      ],
      "label": "Quotas",
      "help": "settings.quotas",
      "widget": null,
      "default": {
        "enforcement": "shadow",
        "sync_interval_seconds": 5,
        "grace_seconds": 900,
        "cold_wait_ms": 150,
        "declared": []
      },
      "required": false,
      "description": "How the proxy enforces the org's quotas (quotas and reporting REQ-084, REQ-093). The quotas themselves are org data in the Usage API, edited in either admin; this section holds how a proxy task applies them, and `declared`, the quotas a deployment pins. Every field is live and may be pinned by the deployment (`NEXUS_SET_QUOTAS_*`); the IaC variables that set those pins arrive with TASK-255, together with the stack parameters they need.",
      "apply": "live",
      "customer_editable": false,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": null,
      "env": null,
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": [
        "quotas.enforcement",
        "quotas.sync_interval_seconds",
        "quotas.grace_seconds",
        "quotas.cold_wait_ms",
        "quotas.declared"
      ]
    },
    {
      "path": "quotas.enforcement",
      "section": "quotas",
      "owner": "quotas-reporting",
      "type": [
        "string"
      ],
      "label": "Enforcement",
      "help": "settings.quotas.enforcement",
      "widget": "select",
      "default": "shadow",
      "required": true,
      "description": "`on` refuses a request past a `block` quota with 429; `shadow` decides and meters every request but never refuses or signals; `off` neither decides nor meters. `shadow` for the first release, `on` the next.",
      "apply": "live",
      "customer_editable": true,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "quota_enforcement",
      "env": "NEXUS_SET_QUOTAS_ENFORCEMENT",
      "enum": [
        "on",
        "shadow",
        "off"
      ],
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "quotas.sync_interval_seconds",
      "section": "quotas",
      "owner": "quotas-reporting",
      "type": [
        "integer"
      ],
      "label": "Sync interval (seconds)",
      "help": "settings.quotas.sync_interval_seconds",
      "widget": null,
      "default": 5,
      "required": true,
      "description": "Seconds between a task's quota syncs while it has unsent usage; an idle task syncs at least once a minute.",
      "apply": "live",
      "customer_editable": false,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "quota_sync_interval_seconds",
      "env": "NEXUS_SET_QUOTAS_SYNC_INTERVAL_SECONDS",
      "enum": null,
      "pattern": null,
      "minimum": 1,
      "maximum": 60,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "quotas.grace_seconds",
      "section": "quotas",
      "owner": "quotas-reporting",
      "type": [
        "integer"
      ],
      "label": "Standing grace (seconds)",
      "help": "settings.quotas.grace_seconds",
      "widget": null,
      "default": 900,
      "required": true,
      "description": "How old a task's standing may be before it counts as unknown: past it, `open` quotas admit and `closed` quotas refuse with `fetch_error`. The auth grace of REQ-009.",
      "apply": "live",
      "customer_editable": false,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "quota_grace_seconds",
      "env": "NEXUS_SET_QUOTAS_GRACE_SECONDS",
      "enum": null,
      "pattern": null,
      "minimum": 60,
      "maximum": 86400,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "quotas.cold_wait_ms",
      "section": "quotas",
      "owner": "quotas-reporting",
      "type": [
        "integer"
      ],
      "label": "Cold-user wait (ms)",
      "help": "settings.quotas.cold_wait_ms",
      "widget": null,
      "default": 150,
      "required": true,
      "description": "Milliseconds a request from a user the task has no standing for waits on that user's first sync before it is decided without one.",
      "apply": "live",
      "customer_editable": false,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "quota_cold_wait_ms",
      "env": "NEXUS_SET_QUOTAS_COLD_WAIT_MS",
      "enum": null,
      "pattern": null,
      "minimum": 0,
      "maximum": 1000,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": null,
      "unique_items": false,
      "items": null,
      "children": []
    },
    {
      "path": "quotas.declared",
      "section": "quotas",
      "owner": "quotas-reporting",
      "type": [
        "array"
      ],
      "label": "Declared quotas",
      "help": "settings.quotas.declared",
      "widget": "json",
      "default": [],
      "required": true,
      "description": "Quotas the deployment pins. The API adopts a reported pin as quotas of this installation (`source = installation`), read-only in both admins and applied alongside the admin-defined ones (tightest wins); removing one removes its quota after the next report. A deployment pin only: neither admin edits it. Every member of an entry is written out, `null` where it does not apply, so the document has one shape on both sides of the wire: `team` is set for the `team` and `team_member` scopes and `user` for `user` (neither for any other), `basis` is `price` for `spend` and `null` otherwise; adoption refuses an entry that breaks either pair.",
      "apply": "live",
      "customer_editable": false,
      "customer_readonly": false,
      "staff_only": false,
      "secret_ref": false,
      "server_generated": false,
      "deprecated": false,
      "scope": "installation",
      "iac": "quota_declared_json",
      "env": "NEXUS_SET_QUOTAS_DECLARED",
      "enum": null,
      "pattern": null,
      "minimum": null,
      "maximum": null,
      "min_length": null,
      "max_length": null,
      "min_items": null,
      "max_items": 100,
      "unique_items": false,
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "name",
          "scope",
          "team",
          "user",
          "metric",
          "basis",
          "period",
          "limit",
          "thresholds_bp",
          "enforcement",
          "grace_bp",
          "fail_mode"
        ],
        "properties": {
          "name": {
            "description": "The quota's label, unique among the installation's declared quotas; the 429 text uses it when the scope has no name.",
            "type": "string",
            "minLength": 1,
            "maxLength": 100
          },
          "scope": {
            "description": "What the quota caps: the org, one team, one user, or each member of the org or of one team.",
            "type": "string",
            "enum": [
              "org",
              "team",
              "user",
              "org_member",
              "team_member"
            ]
          },
          "team": {
            "description": "The team's external id, for the `team` and `team_member` scopes.",
            "type": [
              "string",
              "null"
            ],
            "minLength": 1,
            "maxLength": 200
          },
          "user": {
            "description": "The user's email address or external id, for the `user` scope.",
            "type": [
              "string",
              "null"
            ],
            "minLength": 1,
            "maxLength": 254
          },
          "metric": {
            "description": "`spend` in integer µUSD at the org's price, `tokens` (input + output + cache-write) or `requests`.",
            "type": "string",
            "enum": [
              "spend",
              "tokens",
              "requests"
            ]
          },
          "basis": {
            "description": "A `spend` quota's basis: the org's own `price`, the only one a deployment declares; `null` on the other metrics.",
            "type": [
              "string",
              "null"
            ],
            "enum": [
              "price",
              null
            ]
          },
          "period": {
            "description": "The UTC calendar period the quota counts over; a week starts on Monday.",
            "type": "string",
            "enum": [
              "day",
              "week",
              "month"
            ]
          },
          "limit": {
            "description": "The cap in the metric's unit (integer µUSD for `spend`).",
            "type": "integer",
            "minimum": 1,
            "maximum": 9007199254740991
          },
          "thresholds_bp": {
            "description": "Warning thresholds in basis points of the limit, ascending; `[7500, 9500]` is what an admin-defined quota starts with, `[]` none.",
            "type": "array",
            "maxItems": 5,
            "uniqueItems": true,
            "items": {
              "type": "integer",
              "minimum": 1,
              "maximum": 9999
            }
          },
          "enforcement": {
            "description": "`block` refuses past the limit and grace; `warn` only signals.",
            "type": "string",
            "enum": [
              "block",
              "warn"
            ]
          },
          "grace_bp": {
            "description": "How far past the limit a `block` quota still admits, in basis points (0, the usual value, refuses at 100 %).",
            "type": "integer",
            "minimum": 0,
            "maximum": 5000
          },
          "fail_mode": {
            "description": "What a task does when it cannot learn the standing: admit (`open`, the usual value) or refuse with `fetch_error` (`closed`).",
            "type": "string",
            "enum": [
              "open",
              "closed"
            ]
          }
        }
      },
      "children": []
    }
  ]
};
